import React from 'react';
import generic_logo_club from '../../assets/images/logo_generic_club.png';

const onImageError = (e) => {
    if (e.currentTarget.src === generic_logo_club) {
        // If it's already the placeholder image and we have the problem, we remove the image
        e.currentTarget.remove();
    } else {
        e.currentTarget.src = generic_logo_club;
    }
};

export const StructureLogoOrGeneric = ({ imageUrl, title, className }) => {
    return (
        <img
            src={imageUrl ?? generic_logo_club}
            title={title}
            alt=""
            onError={onImageError}
            className={className}
        />
    );
};
